import React from "react"

export const PencilFill = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        // eslint-disable-next-line max-len
        d="M0.25 13.75V10.5625L10.15 0.68125C10.3 0.54375 10.4656 0.4375 10.6469 0.3625C10.8281 0.2875 11.0188 0.25 11.2188 0.25C11.4188 0.25 11.6125 0.2875 11.8 0.3625C11.9875 0.4375 12.15 0.55 12.2875 0.7L13.3188 1.75C13.4688 1.8875 13.5781 2.05 13.6469 2.2375C13.7156 2.425 13.75 2.6125 13.75 2.8C13.75 3 13.7156 3.19063 13.6469 3.37188C13.5781 3.55313 13.4688 3.71875 13.3188 3.86875L3.4375 13.75H0.25ZM11.2 3.85L12.25 2.8L11.2 1.75L10.15 2.8L11.2 3.85Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default PencilFill
